export default "__VITE_ASSET__bdba3507__"